import React, { useEffect, useRef, useState } from "react";
import { MaskedTextBoxComponent } from "@syncfusion/ej2-react-inputs";
import { MaskedFieldProps } from "./MaskedField";
import { useOverflowTooltip } from "../../../../utils/field";

export const useMaskedField = (props: MaskedFieldProps) => {
  const [localValue, setLocalValue] = React.useState<string | undefined>(
    props.value
  );
  const maskedInputRef = useRef<MaskedTextBoxComponent | null>(null);
  const element =
    props.value != null ? maskedInputRef.current?.element : undefined;
  const isTooltipVisible = useOverflowTooltip(element, props.value);

  const [initialized, setInitialized] = useState<boolean>(false);

  // Initialize
  useEffect(() => {
    if (!!maskedInputRef && !!maskedInputRef.current && !initialized) {
      setInitialized(true);
    }
    return () => {
      setInitialized(false);
    };
  }, []);

  useEffect(() => {
    if (props.value !== localValue) {
      setLocalValue(props.value);
    }
  }, [props.value]);

  useEffect(() => {
    if (initialized) {
      props.onSubmit && props.onSubmit(localValue);
    }
  }, [localValue]);

  return {
    localValue,
    setLocalValue,
    maskedInputRef,
    isTooltipVisible,
  };
};
